import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {MessageService} from './message-service.service';
import {catchError} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import {Router} from '@angular/router';
import {ERRORS, PAGES_CONFIG} from '../constants/pages.constants';
import {StateProviderService} from './state-provider.service';
import {errorCodes} from '../constants/error-code.constants';

type ErrorOptions = {
  duration?: number;
};

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingHttpClient {
  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private stateProviderService: StateProviderService,
    private router: Router
  ) {}

  public post<T = any>(url: string, body: any | null, options?: unknown, errorOptions?: ErrorOptions) {
    return this.http.post<T>(url, body, options).pipe(catchError(err => this.handleError<T>(err, errorOptions)));
  }

  public request<T = any>(method: string, url: any | null,  options?: unknown, errorOptions?: ErrorOptions) {
    return this.http.request<T>(method, url, options).pipe(catchError(err => this.handleError<T>(err, errorOptions)));
  }

  get<T = any>(url: string, options?: unknown, errorOptions?: ErrorOptions) {
    return this.http.get<T>(url, options).pipe(catchError(err => this.handleError<T>(err, errorOptions)));
  }

  public put<T = any>(url: string, body: any | null, options?: unknown, errorOptions?: ErrorOptions) {
    return this.http.put<T>(url, body, options).pipe(catchError(err => this.handleError<T>(err, errorOptions)));
  }

  public delete<T = any>(url: string, options?: unknown, errorOptions?: ErrorOptions) {
    return this.http.delete<T>(url, options).pipe(catchError(err => this.handleError<T>(err, errorOptions)));
  }

  public handleError<T = any>(error: HttpErrorResponse, errorOptions?: ErrorOptions): Observable<T> {
    let errorPromise = Promise.resolve(error?.error);
    if (error.error instanceof Blob) {
      errorPromise = new Response(error.error).text().then(errorDetailsJson => {
        try {
          return JSON.parse(errorDetailsJson);
        } catch (e) {
          return {message: `${error.status} ${error.statusText}`};
        }
      });
    }
    errorPromise.then(errorDetails => this.displayError(error.status, errorDetails, errorOptions));
    return throwError(error);
  }

  private displayError(status: number, errorDetails: any, errorOptions: ErrorOptions = {}) {
    const {duration} = errorOptions;
    const errorMessage = errorDetails?.message;
    if (status === errorCodes.FORBIDDEN) {
      this.stateProviderService.putParam('error', ERRORS.permission);
      this.router.navigate([PAGES_CONFIG.ERROR]);
    } else if (status === errorCodes.NOT_FOUND) {
      this.stateProviderService.putParam('error', ERRORS.notFound);
      this.messageService.showSystemMessage('error', 'Could not perform action', errorMessage, duration);
    } else {
      this.messageService.showSystemMessage('error', 'Could not perform action', errorMessage, duration);
    }
  }
}
